<template>
       <div>
        <template v-if="loader.loading">
        </template>
        <template v-if="humanRequest">
            <RichResponseListItem
                :iconType="getStatusIcon().iconType"
                :icon="getStatusIcon().iconId"
                :title="humanRequest?.topic??''"
            >
                <ion-chip
                    class="small"
                    :color="
                        humanRequest.status === HumanRequestStatus.TaskCompleted
                        || humanRequest.status === HumanRequestStatus.RequestResolved ?  'success' : 'warning'"
                >
                    {{ statusText }}
                </ion-chip>
<!--                    {{ humanRequest.question }}-->
            </RichResponseListItem>
            <RichResponseListItem
                iconType="ion"
                :icon="helpCircleOutline"
                title="Frage"
            >
                {{ humanRequest.question }}
            </RichResponseListItem>
            <RichResponseListItem
                v-if="humanRequest.response"
                iconType="ion"
                :icon="alertCircleOutline"
                title="Antwort"
            >
                {{ humanRequest.response }}
            </RichResponseListItem>
<!--                style="margin-bottom: 5px /*@TWINKIIII*/"-->
<!--            {{ statusText }}-->
<!--            <h2>Antwort</h2>-->
<!--            <h2>{{ humanRequest.response }}</h2>-->

            <div
                class="section-actions"
            >
                <ion-button
                    v-if="
                        humanRequest.status === HumanRequestStatus.Pending
                        || humanRequest.status === HumanRequestStatus.InProgress
                    "
                    @click="onRemove"
                    expand="block"
                    color="light"
                >
                    Anfrage zurückziehen
                </ion-button>
                <ion-button
                    v-if="humanRequest.status === HumanRequestStatus.TaskCompleted"
                    @click="onAccept"
                    expand="block"
                    color="primary"
                >
                    Anfrage schließen
                </ion-button>
            </div>
        </template>
       </div>
</template>

<script setup lang="ts">
import {HumanRequest, HumanRequestStatus} from "@/graphql/generated/graphql";
import {IonButton, IonChip} from "@ionic/vue";
import {computed, ref, Ref} from "vue";
import {DataLoader} from "@/helper/dataLoader";
import {fetchHumanRequest, setHumanRequestStatus} from "@/helper/chat/humanRequests";
import {kapitelErrorHandler} from "@/helper/error";
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import {
    alertCircleOutline,
    checkboxOutline, checkmarkCircleOutline,
    closeCircleOutline,
    helpCircleOutline,
    hourglassOutline
} from "ionicons/icons";


const props = defineProps({
    // month start
    initData: {
        type: String,
        required: true
    }
})
const humanRequest: Ref<HumanRequest|undefined> = ref(undefined)

const statusText: Ref<string> = computed(()=>{
    switch (true){
        case humanRequest.value?.status === HumanRequestStatus.Pending:
            return "Warten auf Bearbeitung"
        case humanRequest.value?.status === HumanRequestStatus.InProgress:
            return "In Bearbeitung"
        case humanRequest.value?.status === HumanRequestStatus.TaskCompleted:
            return "Fertig bearbeitet"
        case humanRequest.value?.status === HumanRequestStatus.RequestResolved:
            return "Antwort akzeptiert"
        case humanRequest.value?.status === HumanRequestStatus.Discarded:
            return "Anfrage verworfen"
        default:
            return "Noch keine Antwort."
    }
})


const loader = new DataLoader(
    async () => {

        if(props.initData){
            const requestId = Number(props.initData)
            humanRequest.value = await fetchHumanRequest(requestId)
        }
    }
)

loader.load()

const onRemove = () => {
    if(!humanRequest.value || !humanRequest.value.id){
        kapitelErrorHandler("Human Request not set.")
        return
    }
    setHumanRequestStatus(
        humanRequest.value?.id,
        HumanRequestStatus.Discarded,
    )
    loader.load()
}

const onAccept = () => {
    if(!humanRequest.value || !humanRequest.value.id){
        kapitelErrorHandler("Human Request not set.")
        return
    }
    setHumanRequestStatus(
        humanRequest.value?.id,
        HumanRequestStatus.RequestResolved,
    )
    loader.load()
}

const getStatusIcon = () => {
    if(!humanRequest.value){
        return {iconId: "/icons/question.svg", iconType: 'icon'}
    }
    switch (true){
        case humanRequest.value.status === HumanRequestStatus.Pending:
            return {
                iconType: "ion",
                iconId: hourglassOutline
            }
        case humanRequest.value.status === HumanRequestStatus.InProgress:
            return {
                iconType: "ion",
                iconId: hourglassOutline
            }
        case humanRequest.value.status === HumanRequestStatus.TaskCompleted:
            return {
                iconType: "ion",
                iconId: checkmarkCircleOutline
            }
        case humanRequest.value.status === HumanRequestStatus.Discarded:
            return {
                iconType: "ion",
                iconId: closeCircleOutline
            }
        case humanRequest.value.status === HumanRequestStatus.RequestResolved:
            return {
                iconType: "ion",
                iconId: checkmarkCircleOutline
            }
    }
    return
}


</script>
<style lang="scss" scoped>
.section-actions {
    width: 100%;
    display: flex;
    margin-top: 0.5em; // alternative: 1em

    ion-button {
        flex: 1 1 100%;
        margin: 0;

        &:not(:last-child) {
            margin-right: 1rem;
        }

    }
}
</style>
